import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Publisher } from '../../_shared/models/publisher.model';

@Injectable({ providedIn: 'root' })
export class PublisherService {
  publishers$ = new Subject<Publisher[]>();
  publishers: Publisher[] = [];
  constructor(private http: HttpClient) {
    this.publishers$.subscribe(publishers => this.publishers = publishers);
    this.getPublishers().subscribe(res => this.publishPublisherUpdate(res.data));
  }

  getPublishers() {
    return this.http.get<any>('api_endpoint' + '/publisher/');
  }

  subscribePublisherUpdates(): Observable<Publisher[]> {
    return this.publishers$.asObservable();
  }

  publishPublisherUpdate(teams: Publisher[]) {
    this.publishers$.next(teams);
  }

  createPublisher(payload) {
    return this.http.post<any>('api_endpoint' + '/publisher/', payload);
  }

  updatePublisher(id, payload) {
    return this.http.put<any>(`api_endpoint/publisher/${id}`, payload);
  }

  getAllSubscriptionPartner() {
    return this.http.get<any>(`api_endpoint/publisher/all-subscription-partner`);
  }

  addPartnerSubscription(publisherId: string, partnerName: string, autoSubscription: boolean) {
    return this.http.post<any>(
      `api_endpoint/publisher/${publisherId}/partner-subscription`,
      { partnerName, autoSubscription }
    );
  }

  deletePartnerSubscription(publisherId: string, partnerName: string) {
    return this.http.delete<any>(
      `api_endpoint/publisher/${publisherId}/partner-subscription/${partnerName}`
    );
  }

  updatePartnerName(publisherId: string, oldName: string, newName: string) {
    return this.http.patch<any>(
      `api_endpoint/publisher/${publisherId}/partner-subscription/${oldName}/rename`,
      { newPartnerName: newName }
    );
  }

  updatePartnerAutoSubscription(publisherId: string, partnerName: string, autoSubscription: boolean) {
    return this.http.patch<any>(
      `api_endpoint/publisher/${publisherId}/partner-subscription/${partnerName}`,
      { autoSubscription }
    );
  }
}
